import { render } from "./UserSetupComponent.vue?vue&type=template&id=14d6ac5d&scoped=true"
import script from "./UserSetupComponent.vue?vue&type=script&lang=js"
export * from "./UserSetupComponent.vue?vue&type=script&lang=js"

import "./UserSetupComponent.vue?vue&type=style&index=0&id=14d6ac5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d6ac5d"]])

export default __exports__